// extracted by mini-css-extract-plugin
export default {"star":"StarToggle--star--Miasb","active":"StarToggle--active--1MIjs"};